import allowedDocumentMimeTypes, {
  extensionToMimeType,
} from 'constants/allowedDocumentMimeTypes';
import { FileExtension, MimeType, fileTypeFromBuffer } from 'file-type';

const getMimeTypeFromExtension = (
  fileName: string
): { mime: MimeType; ext: FileExtension } | null => {
  const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
  const mimeType = extensionToMimeType[extension] as MimeType;

  if (!mimeType) {
    return null;
  }

  // Remove the leading dot from extension for the 'ext' property
  const ext = extension.substring(1) as FileExtension;

  return { mime: mimeType, ext };
};

export const allowedFileDocument = async (file: File) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    let fileTypeResult = await fileTypeFromBuffer(new Uint8Array(arrayBuffer));

    if (!fileTypeResult) {
      const fallbackResult = getMimeTypeFromExtension(file.name);
      if (fallbackResult) {
        fileTypeResult = fallbackResult;
      }
    }

    if (
      !fileTypeResult ||
      !allowedDocumentMimeTypes.includes(fileTypeResult.mime)
    ) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};
